"use strict";

exports.__esModule = true;
exports.DataClearFiltersPropTypes = void 0;
var _propTypes = require("../Button/propTypes");
var DataClearFiltersPropTypes = exports.DataClearFiltersPropTypes = _propTypes.ButtonPropTypes;